import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import { Typography, TextField, Button, MenuItem, Modal } from "@mui/material";
import { postAdduser, rolesList } from "../Service";
import Swal from "sweetalert2";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import LoadingButton from "@mui/lab/LoadingButton";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import { addLog } from "../../utils/addLog";
import { useTranslation } from "react-i18next";
import { signOut } from "../../utils/signOut";
import { departmentList } from "../../utils/departmentList";

const styleModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 450,
  height: 200,
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 3,
};

export default function AddUser() {
  const [t, i18n] = useTranslation("global");

  const [userData, setUserData] = React.useState(
    JSON.parse(sessionStorage.getItem("authUserData"))
  );
  const navigate = useNavigate();

  const [role, setRole] = React.useState("");
  const [department, setDepartment] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [firstName, setFirstName] = React.useState("");
  const [dataRoles, setDataRoles] = React.useState([]);

  // validation err Text
  const [errTextFname, setErrTextFname] = React.useState("");
  const [errFname, setErrFname] = React.useState(false);
  const [errTextEmail, setErrTextEmail] = React.useState("");
  const [errEmail, setErrEmail] = React.useState(false);
  const [errTextRole, setErrTextRole] = React.useState("");
  const [errRole, setErrRole] = React.useState(false);
  const [errDepartment, setErrDepartment] = React.useState(false);
  const [errTextDepartment, setErrTextDepartment] = React.useState("");

  const [openModal, setOpenModal] = useState(false);
  const [loadingbutton, setloadingbutton] = useState(false);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleClickModal = () => {
    setloadingbutton(true);
    addUser();
    addLog("User", "Add", null);
  };

  React.useEffect(() => {
    listRoles();
  }, []);

  const listRoles = () => {
    let qString = "?";

    rolesList(qString).then((res) => {
      if (res && res.status === 200) {
        setDataRoles(res.data);
      } else if (res.status === 401) {
        signOut();
      }
    });
  };

  //////////////// Add User ////////////////

  const addUser = () => {
    if (errEmail) {
      setloadingbutton(false);
      handleCloseModal();
      Swal.fire({
        icon: "error",
        text: t("user.warn.email"),
      });
      return;
    }
    const dataForm = {
      email: email,
      name: firstName,
      department: department,
      role: role,
      created_by: userData.userID,
    };

    postAdduser(dataForm).then((response) => {
      setloadingbutton(false);
      handleCloseModal();
      if (response && (response.status === 200 || response.status === 201)) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: t("user.success.add"),
          showConfirmButton: false,
        });
        navigate("/user");
      } else {
        console.log(
          "API response error1 [" + response.status + "]",
          response.data.err
        );
        Swal.fire({
          icon: "error",
          text: t("user.err.add"),
        });
        if (response.status === 409) {
          setErrTextEmail(t("user.warn.dup_email"));
          setErrEmail(true);
        }
      }
    });
  };

  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }

  return (
    <Box
      style={{
        margin: "65px 0px 0px 0px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/*  ////////////////////////// Breadcrumbs ////////////////////////// */}

      <Box style={{ display: "flex" }}>
        <div role="presentation">
          <Breadcrumbs aria-label="breadcrumb">
            <Link
              underline="hover"
              to={`/user`}
              style={{ textDecoration: "none", color: "#9e9e9e" }}
            >
              <Typography
                style={{
                  fontSize: "1.2rem",
                  fontWeight: "400",
                }}
              >
                {t("user.header")}
              </Typography>
            </Link>

            <Typography
              style={{
                fontSize: "1.2rem",
                fontWeight: "400",
                color: "#212121",
              }}
            >
              {t("user.subtitle.add")}
            </Typography>
          </Breadcrumbs>
        </div>
      </Box>

      {/*  ////////////////////////// Form Add User ////////////////////////// */}
      <Box
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          style={{
            display: "flex",
            marginTop: "25px",
            alignItems: "center",
          }}
        >
          <GroupAddIcon fontSize="large" sx={{ mr: "5px" }} />
          <Typography
            style={{
              fontWeight: "400",
              color: "#1565c0",
              fontSize: "1.5rem",
            }}
          >
            {t("user.subtitle.add")}
          </Typography>
        </Box>

        <Box component="form" noValidate autoComplete="off">
          <Box sx={{ mt: 3, display: "flex" }}>
            <Box sx={{ width: 400, mr: 4 }}>
              <TextField
                label={t("user.txtbox.user.name")}
                variant="outlined"
                size="middle"
                fullWidth
                value={firstName}
                error={errFname}
                onChange={(e) => {
                  setFirstName(e.target.value);
                  if (e.target.value) {
                    setErrTextFname("");
                    setErrFname(false);
                  } else {
                    setErrTextFname(t("user.warn.name"));
                    setErrFname(true);
                  }
                }}
                helperText={errTextFname}
              />
            </Box>
          </Box>

          <Box sx={{ mt: 3, display: "flex" }}>
            <Box sx={{ width: 400, mr: 4 }}>
              <TextField
                label={t("user.txtbox.user.email")}
                variant="outlined"
                size="middle"
                fullWidth
                value={email}
                error={errEmail}
                onChange={(e) => {
                  setEmail(e.target.value);
                  if (!isValidEmail(e.target.value)) {
                    setErrTextEmail(t("user.warn.email"));
                    setErrEmail(true);
                  } else {
                    setErrTextEmail(null);
                    setErrEmail(false);
                  }
                }}
                helperText={errTextEmail}
              />
            </Box>
          </Box>

          <Box sx={{ mt: 3, display: "flex" }}>
            <Box sx={{ width: 400 }}>
              <TextField
                size="middle"
                fullWidth
                select
                label={t("user.txtbox.user.department")}
                value={department}
                error={errDepartment}
                onChange={(e) => {
                  setDepartment(e.target.value);
                  if (e.target.value) {
                    setErrTextDepartment("");
                    setErrDepartment(false);
                    setRole("");
                  } else {
                    setErrTextDepartment("Department is required");
                    setErrDepartment(true);
                  }
                }}
                helperText={errTextDepartment}
              >
                {departmentList.map((option) => (
                  <MenuItem key={option.id} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </Box>
          </Box>

          <Box sx={{ mt: 3, display: "flex" }}>
            <Box sx={{ width: 400 }}>
              <TextField
                size="middle"
                fullWidth
                select
                label={t("user.txtbox.user.role")}
                value={role}
                error={errRole}
                onChange={(e) => {
                  setRole(e.target.value);
                  if (e.target.value) {
                    setErrTextRole("");
                    setErrRole(false);
                  } else {
                    setErrTextRole("Role is required");
                    setErrRole(true);
                  }
                }}
                helperText={errTextRole}
                disabled={!department}
              >
                {dataRoles
                  .filter((row) => row.description.includes(department))
                  .map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                      {option.description}
                    </MenuItem>
                  ))}
              </TextField>
            </Box>
          </Box>
        </Box>
      </Box>

      {/*  ////////////////////////// Action Button ////////////////////////// */}

      <Box
        sx={{
          mt: 9,
          width: 400,
          display: "flex",
          justifyContent: "start",
        }}
      >
        <Box>
          <Button
            variant="contained"
            size="middle"
            style={{ backgroundColor: "#32B917", marginRight: "15px" }}
            onClick={() => {
              if (firstName.length === 0) {
                setErrFname(true);
                setErrTextFname(t("user.warn.name"));
              }
              if (email.length === 0) {
                setErrEmail(true);
                setErrTextEmail(t("user.warn.email"));
              }
              if (department.length === 0) {
                setErrDepartment(true);
                setErrTextDepartment("กรุณาเลือก Department*");
              }
              if (role.length === 0) {
                setErrRole(true);
                setErrTextRole(t("user.warn.role"));
              }
              if (firstName && email && department && role) {
                handleOpenModal();
              }
            }}
          >
            <Typography fontSize={14}>{t("user.button.add")}</Typography>
          </Button>

          <Link
            underline="hover"
            to={`/user`}
            style={{ textDecoration: "none" }}
          >
            <Button variant="contained" size="middle" color="inherit">
              <Typography fontSize={14} style={{ color: "#212121" }}>
                {t("common.button.cancel")}
              </Typography>
            </Button>
          </Link>
        </Box>
      </Box>

      {/* ================== Confirm modal: Add User ================== */}
      <Modal open={openModal}>
        <Box sx={styleModal}>
          <Box style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography marginTop={1} variant="h5" component="h2">
              {t("user.popup.add.header")}
            </Typography>
            <IconButton size="large" onClick={handleCloseModal}>
              <CloseIcon fontSize="inherit" />
            </IconButton>
          </Box>
          <Typography
            sx={{ mt: 3, color: "#616161" }}
            fontSize={14}
            fontWeight={300}
          >
            {t("user.popup.add.txt1")}
          </Typography>
          <Box
            style={{
              display: "flex",
              justifyContent: "end",
              marginTop: "5rem",
            }}
          >
            <LoadingButton
              color="primary"
              onClick={handleClickModal}
              loading={loadingbutton}
              loadingPosition="start"
              startIcon={<SaveIcon />}
              variant="contained"
              size="large"
            >
              {t("user.button.add")}
            </LoadingButton>
            <Button
              style={{ marginLeft: 12 }}
              variant="outlined"
              size="middle"
              color="inherit"
              onClick={handleCloseModal}
            >
              <Typography fontSize={14}>{t("common.button.cancel")}</Typography>
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}
